import React, { useState, useEffect } from "react";
import Dashboard from "../ui/Dashboard.js";
import { fetchUserQuizzes } from "../control/QuizData.js";
import { readRetakeSubmissions } from "../control/RetakeSubmissionData.js";
import FacultyClassesTable from "../ui/FacultyClassesTable.js";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { PDFDocument } from "pdf-lib";
import '../App.css'; // Import the CSS file

export default function FacultyDashboard() {
  const [quizzes, setQuizzes] = useState([]);
  const [submissions, setSubmissions] = useState([]);
  const [pdfArrayBuffer, setPdfArrayBuffer] = useState(null);
  const [error, setError] = useState(null);
  const [loadingPdf, setLoadingPdf] = useState(false);

  useEffect(() => {
    const getQuizzes = async () => {
      setQuizzes(await fetchUserQuizzes());
    };

    const getSubmissions = async () => {
      setSubmissions(await readRetakeSubmissions());
    };

    getQuizzes();
    getSubmissions();
    fetchGoogleDrivePdf("1Fir0_aEeAQGQmy85Wz9fjhhrGi3dC5ZO");
  }, []);

  const fetchGoogleDrivePdf = async (fileId) => {
    setLoadingPdf(true);
    try {
      const url = `https://drive.google.com/uc?export=download&id=${fileId}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const buffer = await response.arrayBuffer();

      const pdfDoc = await PDFDocument.load(buffer);
      if (pdfDoc.getPageCount() === 0) throw new Error("PDF has no pages");

      setPdfArrayBuffer(buffer);
      setError(null);
    } catch (error) {
      console.error("Error fetching PDF:", error);
      setPdfArrayBuffer(null);
    } finally {
      setLoadingPdf(false);
    }
  };

  return (
    <div>
      <Dashboard
        title={<h1 className="dashboard-title">Faculty Dashboard</h1>}
        quizData={quizzes}
        classData={<FacultyClassesTable />}
        submissionData={submissions}
      />

      <div style={{ marginTop: "1rem" }}>
        {loadingPdf && <div>Loading PDF...</div>}
        {error && <div style={{ color: "green" }}>{error}</div>}
        {pdfArrayBuffer && (
          <iframe
            title="PDF Preview"
            src={URL.createObjectURL(new Blob([pdfArrayBuffer], { type: "application/pdf" }))}
            width="100%"
            height="600px"
          />
        )}
      </div>
    </div>
  );
}
